/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Source_Preview_LabelInputs */



/**
* | output |
* | --- |
* | "Source Preview" |
*
* @param {Marker_Import_Source_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_source_preview_label = /** @type {((inputs?: Marker_Import_Source_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Source_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu de la source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellvorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima della fonte")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр исходного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de la fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização da fonte")
	return /** @type {LocalizedString} */ ("Source Preview")
});